import {
  CreativeAssetItem,
  CreativeEditorCapabilities,
} from 'lib.store/src/type-partner/creatives/models';

export type CreativeErrorsType = {
  ['assets.description.0.value']: string;
  ['assets.title.0.value']: string;
  ['assets.cta.0.value']: string;
  ['assets.privacy_policy_url.0.value']: string;
  description: string;
  headline: string;
  call_to_action: string;
  bid: string;
  creativeImage: string;

  // todo check
  logos: string;
};

export type CreativeFormType = {
  strict_validation: boolean;
  title: string;
  bid: number | string;
  template: string;
  event_creative_template_id?: number | null;
  template_version?: number | null;
  channel: number | { id: number };
  editor_capabilities?: CreativeEditorCapabilities;
  type: number;
  assets: CreativeAssetItem;
  status: {
    id: number;
    name: string;
    translate: string;
  };
  preview_url?: string | null;
  is_editable?: boolean;
};

export const creativeFormInitialValues = {
  strict_validation: false,
  title: 'Single Image',
  bid: '',
  template: '',
  // todo change to selected channel
  channel: 2,
  status: {
    id: 1,
    name: 'draft',
    translate: 'Draft',
  },
  is_editable: true,
  assets: {
    title: [
      {
        value: '',
      },
    ],
    short_title: [
      {
        value: '',
      },
    ],
    description: [
      {
        value: '',
      },
    ],
    image_original: [
      {
        value: '',
      },
    ],
    logo_original: [
      {
        value: '',
      },
    ],
    business_name: [
      {
        value: '',
      },
    ],
    cta: [
      {
        value: '',
      },
    ],
    video_original: [
      {
        value: '',
      },
    ],
    privacy_policy_url: [
      {
        value: '',
      },
    ],
  },
};
